(function () {
  const STYLE_ATTR = "data-sh-font-styled";

  function applyFont(el) {
    if (!el || el.getAttribute(STYLE_ATTR) === "true") return true;
    const root = el.shadowRoot;
    if (!root) return false;

    const style = document.createElement("style");
    style.textContent =
      ":host, #shopify-installments, #shopify-installments * {" +
      "font-family: var(--font-body) !important;" +
      "font-weight: var(--font-body-weight);" +
      "font-style: var(--font-body-style);" +
      "letter-spacing: var(--font-body-base-letter-spacing);" +
      "}";
    root.appendChild(style);
    el.setAttribute(STYLE_ATTR, "true");
    return true;
  }

  function watch(el) {
    if (applyFont(el)) return;

    let attempts = 0;
    const timer = setInterval(function () {
      attempts += 1;
      if (applyFont(el) || attempts > 40) clearInterval(timer);
    }, 50);
  }

  function init(scope) {
    (scope || document).querySelectorAll("shopify-payment-terms").forEach(watch);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
